export default "__VITE_ASSET__45b2c066__"